import predicates from '../predicates'
import { DIRECT_TRAFFIC_ID, DIRECT_TRAFFIC_SOURCE } from '../constants'

const direct = {
  rule: predicates.not(
    predicates.referrerExists(),
    predicates.searchParamsIncludeOne('utm_medium', 'utm_source')
  ),
  extractor: traffic => {
    const trafficSource = DIRECT_TRAFFIC_SOURCE
    const trafficId = DIRECT_TRAFFIC_ID

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default direct



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/direct.js